import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import type { IResponseInboxCombine } from 'entities/Inbox/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'

export const useEventInboxCreated = () => {
  const { inboxesStore, websocket } = useEntitiesContext()
  const handle = (data: IResponseInboxCombine) => {
    inboxesStore.addItem(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.InboxCreated, handle), [])
}
